// extracted by mini-css-extract-plugin
module.exports = {"progressRing":"_1FwL10aZUcPJiNkr8lv8c7"};